<template>
  <!-- 工单列表 -->
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        v-if="$store.state.role.role.includes('workorder.create')"
        type="primary"
        @click="workOrderAdd()"
        style=""
        icon="el-icon-circle-plus"
        >新建工单</el-button
      >
      <el-button
        type="primary"
        @click="refreshPage()"
        style=""
        icon="el-icon-refresh"
        >刷新</el-button
      >
      <el-button
        type="primary"
        @click="initPrint('gongDanTable')"
        icon="el-icon-printer"
        >打印</el-button
      >
    </div>

    <div class="rzy-top-bar">
      <div class="rzy-top-bar">
        <div>状态</div>
        <div style="padding-left: 5px; padding-top: 5px;">
          <el-select
            @change="statusSelectChange()"
            clearable
            v-model="pageInfo.status"
            placeholder="请选择状态"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <d-query-input
        style="padding-left: 10px;"
        :options="options"
        @query="queryBySelect"
        @clear="clearQuery"
        width="340px"
        :pageInfo="pageInfo"
      />

      <div style="padding-left: 10px;">
        <el-date-picker
          @change="daterangeSelectChange()"
          v-model="daterangeSelectResult"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
    </div>

    <el-table
      :data="responseData"
      :header-cell-style="setHeaderCellStyle"
      :row-class-name="rowClass"
      :cell-style="setCellStyle"
      border
      stripe
      id="gongDanTable"
    >
      <!--行-->
      <el-table-column sortable prop="local_id" label="行" width="50">
      </el-table-column>

      <!--单据日期-->
      <el-table-column sortable prop="createTime" label="单据日期">
      </el-table-column>

      <!--状态-->
      <el-table-column sortable prop="status_change" label="状态" width="100">
      </el-table-column>

      <!-- 指令单号=>生产编号=>工单编号 -->
      <el-table-column sortable prop="number" label="工单编号" width="160px">
        <!-- 根据workOrderId查询工单 -->
        <template slot-scope="scope">
          <el-link type="primary" @click="goToWorkOrderDetails(scope.row.id)">
            {{ scope.row.number }}
          </el-link>
        </template>
      </el-table-column>

      <!--机台-->
      <el-table-column sortable prop="machineNumber" label="机台" width="80">
      </el-table-column>

      <!-- 产品名称-->
      <el-table-column sortable prop="productName" label="产品名称">
      </el-table-column>

      <!--胚布编号-->
      <el-table-column
        sortable
        prop="materialNumber"
        width="120px"
        label="原料编号"
      >
      </el-table-column>

      <el-table-column sortable prop="materialSpec" label="原料规格">
      </el-table-column>

      <!--门幅=>幅宽 -->
      <el-table-column sortable prop="customer" label="供应商">
      </el-table-column>

      <!--幅数-->
      <el-table-column sortable prop="gbCount" label="盘头数" width="80px">
      </el-table-column>

      <el-table-column sortable prop="headLine" label="头纹数" width="80px">
      </el-table-column>

      <el-table-column sortable prop="dcount" label="D数" width="80px">
      </el-table-column>

      <el-table-column sortable label="盘头尺寸" width="80px">
        <template slot-scope="scope">
          {{ (scope.row.gbSize / 100).toFixed(2) + "英寸" }}
        </template>
      </el-table-column>

      <!--目标产量-->
      <el-table-column
        sortable
        prop="predictProducedLength_change"
        label="已生产米数(米)"
      >
      </el-table-column>

      <!--已完成-->
      <el-table-column
        sortable
        prop="nowProducedLength_change"
        label="已生产重量(米)"
      >
      </el-table-column>

      <el-table-column
        sortable
        prop="predictProducedLength_change"
        label="已生产个数(个)"
      >
      </el-table-column>

      <el-table-column sortable label="已完成">
        <template slot-scope="scope">
          {{
            ((scope.row.finishedGbCount / scope.row.gbCount) * 100).toFixed(2) +
              "%"
          }}
        </template>
      </el-table-column>

      <!--上机状态-->
      <el-table-column sortable prop="workStatus_change" label="状态">
      </el-table-column>
    </el-table>

    <el-pagination
      style="text-align: center"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pageInfo.size"
      :current-page="pageInfo.page"
      :page-count="totalPages"
    >
    </el-pagination>
  </div>
</template>

<script>
import { dQueryInput } from "@/components/projectComponents";
import printJS from "print-js";
export default {
  components: { dQueryInput },

  name: "workOrderList",
  data() {
    return {
      responseData: [],
      remarksButton: [],
      pageInfo: {
        page: 1,
        size: 15,
        //下面是 隐藏的 查询参数--sta
        // status: null, // status 0=审核不通过(待修改), 1=未审核(待审核), 2=已审核, , 3=结案。
        // startTime: null, //开始时间
        // endTime: null, //结束时间
        // fabricNumber: null, //胚布编号
        // fabricName: null, //胚布名称
        //下面是 隐藏的 查询参数--end
      },
      totalPages: 0,
      // 查询--sta
      options: [
        {
          label: "产品名称",
          value: "productName",
        },
      ],
      // 查询--end

      // 状态下拉选择框--sta
      statusList: [
        {
          label: "结案",
          value: "3",
        },
        {
          label: "已审核",
          value: "2",
        },
        {
          label: "待审核",
          value: "1",
        },
        {
          label: "待修改",
          value: "0",
        },
      ],
      // 状态下拉选择框--end

      //日期范围选择控件 -- sta
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      daterangeSelectResult: "", //日期范围 选择的结果
      //日期范围选择控件 -- end
    };
  },
  created() {
    
  },
  computer: {},
  methods: {
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      let that = this;
      let columns = [0, 1, 2, 3, 4, 8, 11]; //想要改变列的索引
      if (columns.indexOf(columnIndex) > -1) {
        //有出现的话就返回center
        return "text-align:center;";
      } else {
        return "text-align:left;padding-left:15px;"; //没有的话就返回left
      }
    },
    setHeaderCellStyle({ row, column, rowIndex, columnIndex }) {
      let that = this;
      let columns = [0, 1, 2, 3, 4, 8, 11]; //想要改变列的索引
      if (columns.indexOf(columnIndex) > -1) {
        //有出现的话就返回center
        return "text-align:center;padding-left:10px; ";
      } else {
        return "text-align:left;padding-left:15px;"; //没有的话就返回left
      }
    },

    rowClass({ row, index }) {
      return `work-order-status${row.status}`;
    },

    // 跳转至新建生产单列表
    workOrderAdd() {
      this.$router.push({
        path: `beamWarping/beamWarpingAdd`,
        query: {
          type: 0, //0=新建, 1=编辑, 2=复制.
          // workOrderId: workOrderId,  不需要
        },
      });
    },

    // 分页切换
    handleCurrentChange(newNum) {
      this.getWorkOrederList(newNum);
    },

    // 获取生产单分页列表
    getWorkOrederList(val) {
      this.pageInfo.page = val;
      this.$requestBase({
        url: "v1/factory/product-order/warper-order/list",
        method: "get",
        params: this.pageInfo,
      }).then((res) => {
        console.log(res);
        this.responseData = this.formatResponse(res.data.list);
        this.totalPages = res.data.pages;
      });
    },
    // 格式化生产单列表
    formatResponse(response) {
      console.log(response);
      response.forEach((item, index) => {
        item.local_id = index + 1;
        item.createTime = this.utils.timestampToTime(item.createTime, 2);

        // status 0=审核不通过(待修改), 1=未审核(待审核), 2=已审核, , 3=结案。
        if (item.status === 3) {
          item.status_change = "结案";
        } else if (item.status === 2) {
          item.status_change = "已审核";
        } else if (item.status === 1) {
          item.status_change = "待审核";
        } else {
          // 0 或者 null
          item.status_change = "待修改";
        }

        // workStatus 上机状态
        // 0 = 准备中  ---->添加工单时，不显示。
        // 1 = 待产    ---->提交工单后，显示 "就绪"="等待"。
        // 3 = 生产中  ---->点击上单后，显示 "上单"="上机"
        // 2 = 暂停    ---->点击下单后，显示 "下单"="下机"
        // 4 = 完成    ---->后台自动切换，显示 "关闭"
        if (item.workStatus === 1) {
          if (item.status === 2) {
            //已审核
            item.workStatus_change = "就绪";
          } else {
            item.workStatus_change = "";
          }
        } else if (item.workStatus === 2) {
          item.workStatus_change = "下单";
        } else if (item.workStatus === 3) {
          item.workStatus_change = "上单";
        } else if (item.workStatus === 4) {
          item.workStatus_change = "关闭";
        } else {
          // 0 或者 null
          item.workStatus_change = "准备中";
        }

        // 目标产量 输入时是米，要转换成厘米，后台是按整数(厘米)存储。
        item.predictProducedLength_change = Number(
          item.predictProducedLength / 100
        );

        // 已完成 输入时是米，要转换成厘米，后台是按整数(厘米)存储。
        item.nowProducedLength_change = Number(item.nowProducedLength / 100);
      });
      return response;
    },
    // 路由至生产单详情
    goToWorkOrderDetails(workOrderId) {
      this.$router.push(`beamWarping/beamWarpingDetalis/${workOrderId}`);
    },
    // 在打印当前报表前，拼接title
    initPrint(id) {
      // // size: A4 portrait;
      // const style = '@page {size: landscape  } ' +
      //             '@media print {.print_table{width: 100%;}}' ;
      // printJS({
      // 	printable: id,
      // 	type: 'html',
      // 	targetStyles: ['*'],
      // 	maxWidth: 1500,
      // 	style: style,
      // 	scanStyles: true,
      // 	header: '出库单详情',
      // 	           // style: `@page {size:auto;margin-top:100px; margin-left:15px; margin-right: 15px;}
      // 	           //  thead th {
      // 	           //    border-top: 2px solid #000;
      // 	           //    border-right: 2px solid #000;
      // 	           //    border-left: 2px solid #000;
      // 	           //  }
      // 	           //  tbody td {
      // 	           //    border: 2px solid #000;
      // 	           //  }
      // 	           //  tbody {
      // 	           //    text-align: center;
      // 	           //  }
      // 	           //  table {
      // 	           //    border-collapse: collapse;
      // 	           //  }`,
      // })

      // return
      this.utils.printTable(id, `工单列表`);
    },
    // 刷新
    refreshPage() {
      this.getWorkOrederList(1);
      this.$Message.success("刷新成功");
    },
    // 条件查询
    queryBySelect(pageInfo) {
      this.pageInfo = pageInfo;
      this.getWorkOrederList(1);
    },
    // 清空条件查询
    clearQuery(pageInfo) {
      this.pageInfo = pageInfo;
      this.getWorkOrederList(1);
    },
    // 状态选择框，内容改变事件
    statusSelectChange() {
      this.refreshPage();
    },

    // 日期范围选择控件，内容改变事件
    daterangeSelectChange() {
      // console.log('daterangeSelectResult=', this.daterangeSelectResult)
      // console.log('daterangeSelectResult[0]=', this.daterangeSelectResult[0])
      // console.log('daterangeSelectResult[1]=', this.daterangeSelectResult[1])

      //开始时间 转 时间戳
      let m_date = new Date(this.daterangeSelectResult[0]);
      let m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
      this.pageInfo.startTime = m_time;
      // console.log('startTime=', this.pageInfo.startTime)

      //结束时间 转 时间戳
      m_date = new Date(this.daterangeSelectResult[1]);
      m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
      this.pageInfo.endTime = m_time;
      // console.log('endTime=', this.pageInfo.endTime)

      this.refreshPage();
    },
  },
  mounted() {
    this.getWorkOrederList(1);
  },
  activated() {
    this.getWorkOrederList(1);
  },
};
</script>

<style lang="scss" scoped>
.define-table-container {
  margin-left: -10px !important;
}
// #bianji {
//   cursor: pointer;
//   alt: '编辑';
// }
p {
  // border: 1px solid #EBEEF5;
  // line-height: 0;
  padding: 0;
  margin: 0;
}
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}
.el-table .success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}
</style>
